import { operatingIndustryToUrlSlug } from "@shared/operatingIndustryUrlSlug";
import {
  GUEST_CORRIDORS_CLUSTERS_PATH,
  GUEST_EXPLORE_CORRIDORS_TAB,
  GUEST_EXPLORE_EXPERTS_TAB,
  GUEST_REGIONAL_SECTOR_EXPERTS_PATH,
} from "@/pages/discover/discoverExplore.const";

export const GUEST_DISCOVER_RETURN_TO = "/";

export { GUEST_EXPLORE_CORRIDORS_TAB, GUEST_EXPLORE_EXPERTS_TAB };

/** Matches logged-in profile pages (`DISCOVER_LOGGED_IN` uses Container fluid). */
export const GUEST_DISCOVER_PROFILE_CONTAINER_SIZE = "100%" as const;

export function guestCorridorProfileHref(industry: string, headUserId: string): string {
  return `${GUEST_CORRIDORS_CLUSTERS_PATH}/${operatingIndustryToUrlSlug(industry)}/${encodeURIComponent(headUserId)}`;
}

/** Corridor when both origin and target countries are set; otherwise cluster. */
export function guestCorridorProfileNavLabel(
  country?: string | null,
  targetCountry?: string | null,
): string {
  const from = country?.trim() ?? "";
  const to = targetCountry?.trim() ?? "";
  if (from && to) return "View Corridor";
  return "View Cluster";
}

export function guestExpertProfileHref(companyId: string): string {
  return `${GUEST_REGIONAL_SECTOR_EXPERTS_PATH}/${encodeURIComponent(companyId)}`;
}
